import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthAPIMService {
  email: string = '';
  roles: string[] = [];
  groups: string[] = [];

  constructor(private msalService: MsalService, private http: HttpClient, private ngZone: NgZone) {
  }

  refreshAccount() {
    const account = this.msalService.instance.getActiveAccount();
    this.email = account?.username || '';
    this.roles = account?.idTokenClaims?.roles || [];
  }

  getAccessToken(scopes: string[] = [`${environment.scopes}`]): Observable<string> {
    const request = {
      scopes: scopes,
    };

    return new Observable<string>(observer => {
      this.msalService.acquireTokenSilent(request).subscribe({
        next: (result: AuthenticationResult) => {
          // MSAL's silent token acquisition (crypto/iframe work) can resolve
          // outside Angular's zone, which would prevent change detection from
          // running for anything downstream of this observable. Force it back
          // into the zone so consumers' bindings (e.g. isLoading) update the view.
          this.ngZone.run(() => {
            observer.next(result.accessToken);
            observer.complete();
          });
        },
        error: (error) => {
          console.error('Token acquisition failed', error);
          this.ngZone.run(() => {
            observer.error(error);
          });
        }
      });
    });
  }
}